import { Component, Input, TemplateRef } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { EdlEntriesFormBuilderService, EdlEntriesFormGroup, EdlEntry } from '@edl-development/edl-common';
import { ModalService } from 'src/app/modals/modal.service';
import { EdlItemPacketEntryDTO } from 'src/app/model/item-packet/edl-item-packet-entry.model';


@Component({
    selector: 'item-packet-filter',
    templateUrl: './item-packet-filter.component.html',
    styleUrls: ['./item-packet-filter.component.scss'],
    viewProviders: [{ 
        provide: ControlContainer, 
        useExisting: FormGroupDirective 
    }]
})
export class ItemPacketFilterComponent {
    @Input() formGroup!: EdlEntriesFormGroup<EdlItemPacketEntryDTO>;
    @Input() itemPackets: EdlItemPacketEntryDTO[] = [];
    @Input() inlineAddButton = true;
    @Input() id?: string;

    constructor(
        private edlEntriesFormBuilderService: EdlEntriesFormBuilderService,
        private modalService: ModalService
    ) { }

    get canAddItemPackets(): boolean {
        return this.formGroup.enabled;
    }


    addItemPackets(itemTemplate?: TemplateRef<any> | null) {
        const edlEntries: EdlEntry<EdlItemPacketEntryDTO>[] = this.itemPackets
            .map((entry: EdlItemPacketEntryDTO) => ({
                id: entry.Id,
                name: entry.Title,
                details: entry
            }));

        const selectedEntries = this.edlEntriesFormBuilderService.toSelectedEntries(this.formGroup);

        this.modalService
            .edlEntriesSelectorFormModal({ edlEntries, selectedEntries, itemTemplate, columnCount: 1 })
            .then((result: EdlEntry<EdlItemPacketEntryDTO>[]) => {
                this.edlEntriesFormBuilderService.updateSelectedFormGroup(this.formGroup, result);
            }, () => { });
    }
}